<div style="margin-left: 80%; margin-bottom: 2%;">
    <button id="print-button" class="noPrint" style="margin-top: 2%; margin-left: 2%; display: none;" mat-raised-button color="primary"
    printSectionId="print-section1" ngxPrint>
  Print
  </button>

  <button (click)="printPage()" class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary">
Print
</button>
    <button class="noPrint" style="margin-top: 2%; margin-left: 2%" (click)="exportExcel('Advt_Invoice_Register')"
        mat-raised-button color="primary">
        Export
    </button>
    <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
        Close
    </button>
</div>  

<ng-container *ngIf="reportType == 'VeryBriefly-Officer'">
  <div class="container" id="print-section1" style="margin-top:50px; margin-right: 3px; margin-left: 3px;">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th colspan="5" style="font-size: medium;">
            हिंदुस्थान प्रकाशन संस्था - विवेक साप्ताहिक - जाहिरात विभाग - Advt Invoice Register
          </th>
          <th colspan="2" style="font-size: medium;">VeryBriefly</th>
          <th colspan="2" style="font-size: medium;">दिनांक - {{ today | date:"dd-MM-yyy" }}</th>
          <th colspan="2" style="font-size: medium;">पृष्ठ क्र.- 1</th>
        </tr>
        <tr>
          <th colspan="5" class="leftAlign"></th>
          <th colspan="3" class="leftAlign"><div>Issue Date :</div></th>
          <th colspan="3" class="leftAlign" style="font-size: medium;">
            <div>Date : From : {{ startDate | date:"dd-MM-yyy" }} To : {{ endDate | date:"dd-MM-yyy" }}</div>
          </th>
        </tr>
        <tr>
          <th style="font-size: 14px !important; text-align: center;">Representative Name</th>
          <th style="font-size: 14px !important; text-align: center;">Advt. <br> Amount</th>
          <th style="font-size: 14px !important; text-align: center;">Discount <br>Amount</th>
          <th style="font-size: 14px !important; text-align: center;">Amount<br>before GST</th>
          <th style="font-size: 14px !important; text-align: center;">CGST</th>
          <th style="font-size: 14px !important; text-align: center;">SGST</th>
          <th style="font-size: 14px !important; text-align: center;">IGST</th>
          <th style="font-size: 14px !important; text-align: center;">Total GST</th>
          <th style="font-size: 14px !important; text-align: center;">Total Invoice <br> Amount</th>
          <th style="font-size: 14px !important; text-align: center;">Paid <br> Amount</th>
          <th style="font-size: 14px !important; text-align: center;">Unpaid<br>Amount</th>
        </tr>
      </thead>

      <tbody>
        <!-- Group by Office Representative -->
        <ng-container *ngFor="let officeGroup of filteredAdvtInvoiceData">
          <tr>
            <td colspan="11" style="font-weight:bold; font-size:16px; background:#97daee; text-align:left;">
              Office Representative : {{ officeGroup.off_rep_name }}
            </td>
          </tr>

          <!-- Loop through representatives under this office representative -->
          <ng-container *ngFor="let repGroup of officeGroup.representatives">
            <tr>
              <td style="font-weight:bold; padding-left:25px;">{{ repGroup.rep_name }}</td>
              <td style="text-align:end; font-weight:bold;">{{ repGroup.rep_advt_amt }}</td>
              <td style="text-align:end; font-weight:bold;">{{ repGroup.rep_discount }}</td>
              <td style="text-align:end; font-weight:bold;">{{ repGroup.rep_beforegst_amt }}</td>
              <td style="text-align:end; font-weight:bold;">{{ repGroup.rep_cgst }}</td>
              <td style="text-align:end; font-weight:bold;">{{ repGroup.rep_sgst }}</td>
              <td style="text-align:end; font-weight:bold;">{{ repGroup.rep_igst }}</td>
              <td style="text-align:end; font-weight:bold;">{{ repGroup.rep_gst }}</td>
              <td style="text-align:end; font-weight:bold;">{{ repGroup.rep_invoice_total }}</td>
              <td style="text-align:end; font-weight:bold;">{{ repGroup.rep_paid_amt }}</td>
              <td style="text-align:end; font-weight:bold;">{{ repGroup.rep_unpaid_amt }}</td>
            </tr>
          </ng-container>

          <!-- Office Representative Total Row -->
          <tr>
            <td style="font-weight:bold; background:#d4edfa; padding-left:10px;">Office Representative Total</td>
            <td style="text-align:end; font-weight:bold; background:#d4edfa;">{{ officeGroup.off_rep_advt_amt }}</td>
            <td style="text-align:end; font-weight:bold; background:#d4edfa;">{{ officeGroup.off_rep_discount }}</td>
            <td style="text-align:end; font-weight:bold; background:#d4edfa;">{{ officeGroup.off_rep_beforegst_amt }}</td>
            <td style="text-align:end; font-weight:bold; background:#d4edfa;">{{ officeGroup.off_rep_cgst }}</td>
            <td style="text-align:end; font-weight:bold; background:#d4edfa;">{{ officeGroup.off_rep_sgst }}</td>
            <td style="text-align:end; font-weight:bold; background:#d4edfa;">{{ officeGroup.off_rep_igst }}</td>
            <td style="text-align:end; font-weight:bold; background:#d4edfa;">{{ officeGroup.off_rep_gst }}</td>
            <td style="text-align:end; font-weight:bold; background:#d4edfa;">{{ officeGroup.off_rep_invoice_total }}</td>
            <td style="text-align:end; font-weight:bold; background:#d4edfa;">{{ officeGroup.off_rep_paid_amt }}</td>
            <td style="text-align:end; font-weight:bold; background:#d4edfa;">{{ officeGroup.off_rep_unpaid_amt }}</td>
          </tr>
        </ng-container>
      </tbody>

      <!-- Grand Totals row -->
      <tr>
        <td style="font-weight: bold; border: 1px solid #000;">Grand Total</td>
        <td style="text-align:end;font-size: medium; font-weight:bold; border:1px solid #000;">{{advtamount}}</td>
        <td style="text-align:end;font-size: medium; font-weight:bold; border:1px solid #000;">{{discountamt}}</td>
        <td style="text-align:end;font-size: medium; font-weight:bold; border:1px solid #000;">{{totalbeforegstamount}}</td>
        <td style="text-align:end;font-size: medium; font-weight:bold; border:1px solid #000;">{{cgst}}</td>
        <td style="text-align:end;font-size: medium; font-weight:bold; border:1px solid #000;">{{sgst}}</td>
        <td style="text-align:end;font-size: medium; font-weight:bold; border:1px solid #000;">{{igst}}</td>
        <td style="text-align:end;font-size: medium; font-weight:bold; border:1px solid #000;">{{gstcst}}</td>
        <td style="text-align:end;font-size: medium; font-weight:bold; border:1px solid #000;">{{invoice_total}}</td>
        <td style="text-align:end;font-size: medium; font-weight:bold; border:1px solid #000;">{{paidamount}}</td>
        <td style="text-align:end;font-size: medium; font-weight:bold; border:1px solid #000;">
          {{invoice_total - paidamount}}
        </td>
      </tr>
    </table>
  </div>
</ng-container>